"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRetryException = exports.isAuthNeededException = exports.RetryError = exports.AuthNeededError = exports.isUriLocation = exports.isAbstractMenuManager = exports.isAppRootModel = exports.isTrackViewModel = exports.isDisplayModel = exports.isTrackModel = exports.isViewModel = exports.isSelectionContainer = exports.isSessionWithSessionPlugins = exports.isSessionModelWithConnections = exports.isSessionModelWithWidgets = exports.isSessionWithAddTracks = exports.isSessionModelWithConfigEditing = exports.isSessionModel = exports.isViewContainer = void 0;
const mobx_state_tree_1 = require("mobx-state-tree");
const TextSearchManager_1 = __importDefault(require("../../TextSearch/TextSearchManager"));
__exportStar(require("./util"), exports);
function isViewContainer(thing) {
    return ((0, mobx_state_tree_1.isStateTreeNode)(thing) &&
        'removeView' in thing &&
        'addView' in thing &&
        'views' in thing);
}
exports.isViewContainer = isViewContainer;
function isSessionModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'rpcManager' in thing &&
        'configuration' in thing);
}
exports.isSessionModel = isSessionModel;
function isSessionModelWithConfigEditing(thing) {
    return isSessionModel(thing) && 'editConfiguration' in thing;
}
exports.isSessionModelWithConfigEditing = isSessionModelWithConfigEditing;
function isSessionWithAddTracks(thing) {
    return isSessionModel(thing) && 'addTrackConf' in thing;
}
exports.isSessionWithAddTracks = isSessionWithAddTracks;
function isSessionModelWithWidgets(thing) {
    return isSessionModel(thing) && 'widgets' in thing;
}
exports.isSessionModelWithWidgets = isSessionModelWithWidgets;
function isSessionModelWithConnections(thing) {
    return isSessionModel(thing) && 'addConnectionConf' in thing;
}
exports.isSessionModelWithConnections = isSessionModelWithConnections;
function isSessionWithSessionPlugins(thing) {
    return isSessionModel(thing) && 'sessionPlugins' in thing;
}
exports.isSessionWithSessionPlugins = isSessionWithSessionPlugins;
function isSelectionContainer(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'selection' in thing &&
        'setSelection' in thing);
}
exports.isSelectionContainer = isSelectionContainer;
function isViewModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'width' in thing &&
        'setWidth' in thing);
}
exports.isViewModel = isViewModel;
function isTrackModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'configuration' in thing &&
        // @ts-ignore
        thing.configuration.trackId);
}
exports.isTrackModel = isTrackModel;
function isDisplayModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'configuration' in thing &&
        // @ts-ignore
        thing.configuration.displayId);
}
exports.isDisplayModel = isDisplayModel;
function isTrackViewModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'showTrack' in thing &&
        'hideTrack' in thing);
}
exports.isTrackViewModel = isTrackViewModel;
function isAppRootModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'isAssemblyEditing' in thing &&
        'findAppropriateInternetAccount' in thing);
}
exports.isAppRootModel = isAppRootModel;
function isAbstractMenuManager(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'appendMenu' in thing &&
        'appendToSubMenu' in thing);
}
exports.isAbstractMenuManager = isAbstractMenuManager;
function isUriLocation(location) {
    return typeof location === 'object' && location !== null && 'uri' in location;
}
exports.isUriLocation = isUriLocation;
class AuthNeededError extends Error {
    constructor(message, url) {
        super(message);
        this.message = message;
        this.url = url;
        this.name = 'AuthNeededError';
        Object.setPrototypeOf(this, AuthNeededError.prototype);
    }
}
exports.AuthNeededError = AuthNeededError;
class RetryError extends Error {
    constructor(message, internetAccountId) {
        super(message);
        this.message = message;
        this.internetAccountId = internetAccountId;
        this.name = 'RetryError';
    }
}
exports.RetryError = RetryError;
function isAuthNeededException(exception) {
    return (exception instanceof Error &&
        // DOMException
        (exception.name === 'AuthNeededError' ||
            exception.url !== undefined));
}
exports.isAuthNeededException = isAuthNeededException;
function isRetryException(exception) {
    return (
    // DOMException
    exception.name === 'RetryError' ||
        exception.internetAccountId !== undefined);
}
exports.isRetryException = isRetryException;
